import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

export function CacheResponse(): any {
    // tslint:disable-next-line:only-arrow-functions
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        const originalMethod = descriptor.value;
        let cachedObservable: Observable<any>;

        descriptor.value = function (...args: any[]) {
            if (!cachedObservable) {
                cachedObservable = originalMethod.apply(this, args).pipe(
                    shareReplay(1), // Won't stop emitting until it's completed, no matter if there are no subscriptions anymore or not.
                    // publishReplay(1), // Will stop after the last subscriber unsubscribes if used together with refCount.
                    // refCount()
                );
            }

            return cachedObservable;
        };

        return descriptor;
    };
}
